/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["éjfél", "dél", "reggel", "de.", "du.", "este", "éjjel", "hajnal"], u, ["éjfél", "dél", "reggel", "délelőtt", "délután", "este", "éjjel", "hajnal"]], u, ["00:00", "12:00", ["06:00", "09:00"], ["09:00", "12:00"], ["12:00", "18:00"], ["18:00", "21:00"], ["21:00", "04:00"], ["04:00", "06:00"]]];
